import { Pipe, PipeTransform } from '@angular/core';
import { ValueTransformer } from '@angular/compiler/src/util';

@Pipe({
  name: 'extension'
})
export class ExtensionPipe implements PipeTransform {

  transform(value: any, index: number = 1): any {
    let terms = value.split('.');
    if (terms.length > index) {
      let is_encrypted = value.slice(-4) == '.wbc'

      if (index == 1) {
        if (terms.length >= 2) {
          if (is_encrypted && terms.length >= 3) {
            return terms[terms.length - 2];
          }
          return terms[terms.length - 1]
        }
      }

      if (index == 0) {
        if (is_encrypted) {
          terms.splice(terms.length - 1, 1);
        }

        if (terms.length >= 3) {
          terms.splice(terms.length - 1, 1);
          terms.splice(terms.length - 1, 1);
          return terms.join('.');
        }
        return terms[0];
      }
    }
    return '?';
  }

}
